export default "__VITE_ASSET__DvyS6RhX__"